var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { apiGetListRfp } from '@/actions/ProfessionalRfpActions';
import { options } from '@/components/pages/rfp/professional/ProfessionalRfpListView';
import { useSelectSort } from '@/hooks/sort/useSelectSort';
import { RfpProfessionalListPage } from '@/pages/rfp/professional/RfpProfessionalList/RfpProfessionalListPage';
import { useWrapDispatchState, wrapDispatch } from '@/utils/actions/dispatch';
import { professionalRfpListPath } from '@/utils/router/links';
/**
 * コンサルタント：案件一覧ページのコンテンツ取得を行うコンポーネント
 * @constructor
 */
export const RfpProfessionalList = () => {
    // 一覧読み込み
    const dispatch = useDispatch();
    const [rfps, setRfps] = useWrapDispatchState();
    const [rfpsLoading, setRfpsLoading] = useState(false);
    // ソート変更処理
    const { search } = useLocation();
    const { onChangeSort, sort } = useSelectSort({
        defaultSort: options[0].value,
        options,
        path: professionalRfpListPath(),
        search,
    });
    // 一覧の読み込み処理（パラメータが書き換わる度にデータを引き直す）
    useEffect(() => {
        let active = true;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                // ローディング開始
                setRfpsLoading(true);
                // 案件一覧を読み込み
                const res = yield wrapDispatch(dispatch, apiGetListRfp({ query: { sort } }, {}));
                // 結果をstateに保持
                const { payload } = res;
                setRfps(payload.list);
            }
            finally {
                if (active) {
                    // ローディング終了
                    setRfpsLoading(false);
                }
            }
        }))();
        return () => {
            active = false;
        };
    }, [dispatch, setRfps, setRfpsLoading, sort]);
    return (_jsx(RfpProfessionalListPage, { loading: rfpsLoading, onChangeSort: onChangeSort, rfps: rfps, sort: sort }));
};
